<template>
  <div class="overflow-y-auto" style="height: calc(100vh - 65px)">
    <div class="mx-auto text-dark w-full px-5 md:px-10 lg:px-0 lg:w-1/2 max-w-5xl">
      <!-- Loader -->
      <portal to="loaderTarget">
        <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
          <gd-loader :label="$t('frontend_loading')"/>
        </div>
      </portal>

      <div class="text-center my-12" style="font-size: 28px">
        {{ $t('frontend_groovemail_preview_form_route_page_title') }}
      </div>

      <div class="text-xs text-grey-700">
        {{ $t('frontend_groovemail_forms_select_a_preset') }}
      </div>

      <gd-dropdown
        class="mt-2 mb-6 text-sm"
        v-model="selectedPreset"
        :options="presetsSelect"
        :placeholder="$t('frontend_groovemail_forms_select_a_preset')"
        size="full"
      />
      
      <iframe
        v-if="iframeUrl"
        v-iframe-resize
        class="form-content-box mb-20"
        id="preview-form-iframe"
        :src="iframeUrl"
        style="min-width: 100%; min-height: 150px; pointer-events:none;"
      ></iframe>


      <div id="form-name" class="mb-20">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_admin_forms_form_name') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            {{ localModel.name }}
          </div>
        </div>
      </div>

      <div class="mb-20" id="subscriber-list">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_forms_step4_subscribe') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            <div v-if="localModel.lists.length > 0">
              <div v-for="list in localModel.lists" :key="list.id">
                {{ list.name }}
              </div>
            </div>
            <div v-if="localModel.lists.length === 0">{{$t('frontend_groovemail_forms_step4_dont_assign_list')}}</div>
          </div>
        </div>
      </div>

      <div class="mb-20" id="subscriber-tags">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_forms_step4_assigntags') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            <div v-if="localModel.tags.length > 0">
              <div v-for="tag in localModel.tags" :key="tag.id">
                {{ tag.name }}
              </div>
            </div>
            <div v-if="localModel.tags.length === 0">{{$t('frontend_groovemail_forms_step4_dont_assign_tag')}}</div>
          </div>
        </div>
      </div>

      <div class="mb-20" id="sequences">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_lead_detail_sequence_tab') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            <div v-if="localModel.sequences.length > 0">
              <div v-for="tag in localModel.sequences" :key="tag.id">
                {{ tag.name }}
              </div>
            </div>
            <div v-if="localModel.sequences.length === 0">{{$t('frontend_groovemail_forms_step4_dont_assign_sequence')}}</div>
          </div>
        </div>
      </div>
      <div class="mb-20" id="optin_setting">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_forms_step2_option_setting') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            {{ localModel.optin ? localModel.optin : $t('frontend_groovemail_forms_null_option')}}
          </div>
        </div>
      </div>

      <div class="mb-20" id="welcome_message_option">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_forms_step3_welcome') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            {{
              localModel.welcome_msg_option
                ? localModel.welcome_msg_option
                : $t('frontend_groovemail_forms_null_option')
            }}
          </div>
        </div>
      </div>

      <div class="mb-20" id="success_pageurl">
        <div class="text-2xl font-bold">
          {{ $t('frontend_groovemail_forms_step2_success') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            {{ localModel.success_pageurl}}
          </div>
        </div>
      </div>
      <div class="mb-20" id="integrations">
        <div class="text-2xl font-bold">
          {{ $t('Integrations') }}
        </div>
        <div class="form-content-box p-5">
          <div style="width: 400px">
            {{ $t('forntend_groovemail_previewforms_memberships') }}: {{ localModel.integrations?.memberships?.length ?? 0}}<br/>
            {{ $t('forntend_groovemail_previewforms_integrations') }}: {{ localModel.integrations?.integrations?.length ?? 0}}<br/>
            {{ $t('forntend_groovemail_previewforms_webhooks') }}: {{ localModel.integrations?.webhooks?.length ?? 0}}<br/>
            {{ $t('forntend_groovemail_previewforms_files') }}: {{ localModel.integrations?.files?.length ?? 0}}<br/>
            <span
              class="text-sm text-primary cursor-pointer font-bold"
              @click="goToIntegrations"
            >
              {{ $t('forntend_groovemail_previewforms_view_edit_the_integrations') }}
            </span>
          </div>
        </div>
      </div>
      
      <portal to="headerContent">
        <div class="h-10 flex flex-row">
        </div>
      </portal>
      <portal to="headerBreadCrumb">
        <div
          class="flex h-full items-center cursor-pointer text-grey-500 hover:text-primary"
          @click="moveBackToFormListing"
        >
          <ExitIcon class="w-5 h-5"/>
        </div>
      </portal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import Mailform from '@/models/Mailform';
import themeConfig from '@/theme/themeConfig.js';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import ExitIcon from '@/assets/images/icons/new/exit_arrow_new.svg';

export default {
  name: 'PreviewForm',
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',
  metaInfo() {
    return { title: this.$t('frontend_forms') };
  },
  components: {
    Treeselect,
    ExitIcon,
  },
  data() {
    return {
      selectedPreset: null,
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      emailReg:
        '[_a-zA-Z0-9-]+(.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})',
      telephoneInputId: '',
      localModel: {
        name: '',
        form_fields: [],
        form_heading: this.$t(
          'frontend_groovemail_forms_form_creation_form_heading_default'
        ),
        form_sub_heading: this.$t(
          'frontend_groovemail_forms_form_creation_form_sub_heading_default'
        ),
        form_submit_button_text: '',
        formid: '',
        lists: [],
        tags: [],
        sequences: [],
        integrations: {},
        optin: '',
        welcome_msg_option: '',
      },
    };
  },
  computed: {
    formFieldsData() {
      if (typeof this.localModel.form_fields.fields === 'undefined'){
        return this.localModel.form_fields;
      }
      else {
        return this.localModel.form_fields.fields;
      }
    },
    iframeUrl() {
      if (this.localModel.formid === '') return null;
        const permalink = btoa(this.localModel.formid);
        return `${window.config.grooveappsurl}${this.$router.options.base}embedForm/view/${permalink}?variation=${this.selectedPreset}`;
    },
    ...mapState({
      presets: state => state.forms.presets,
    }),
    presetsSelect() {
      // get the list of presets that are not a local preset
      const presetsList = this.presets.filter(preset => preset.form_id === null || preset.form_id === undefined);

      // get the target form local preset if it exists
      const targetPreset = this.presets.find(preset => preset.form_id === this.localModel.formid);

      if(targetPreset) {
        // Add a new value to the top of the array
        presetsList.unshift(targetPreset);
      }

      return presetsList.map((variant) => {
        return {value: variant.id, text: variant.name };
      });
    },
  },

  async mounted() {
    try {
      // show loader
      this.showLoader();
      
      await this.$store.dispatch('forms/loadPresets');
      this.selectedPreset = this.presets.find(i => i.default === true)?.id ?? this.presets[0].id;
      
      const response = await Mailform.$find(this.$route.params.id);
      this.localModel.formid = this.$route.params.id;
      this.telephoneInputId = `telephone_input${this.localModel.formid}`;
      this.localModel.name = response?.name;
      this.localModel.default_preset = response?.default_preset??'';
      this.localModel.form_fields = JSON.parse(response?.form_fields);
      // this.localModel.form_fields.fields
      this.localModel.lists = JSON.parse(response?.lists);
      this.localModel.tags = JSON.parse(response?.tags);
      this.localModel.sequences = JSON.parse(response?.sequences);
      this.localModel.integrations = JSON.parse(response?.integrations??'{}');
      this.localModel.form_submit_button_text = response?.form_submit_button_text;
      this.localModel.optin = response?.optin;
      this.localModel.welcome_msg_option = response?.welcome_msg_option;
      this.localModel.success_pageurl = response?.success_pageurl;
      if (this.localModel.default_preset !== '' && this.presets.find(i => i.id === this.localModel.default_preset)) {
        this.selectedPreset = this.localModel.default_preset;
      }

      // hide loader
      this.hideLoader();
    } catch (error) {
      this.requestErrorAlert(error.response?.data?.error);
    }
  },

  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },


    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    async moveBackToFormListing() {
      this.$router.push({ name: 'Forms' });
    },
    async goToIntegrations() {
      this.$parent.$el.scrollTo(0,0);
      this.$router.push({ name: 'EditForm', params: { id: this.localModel.formid }, query: {step: 'integrations'}});
    },
  },
};
</script>
